/* eslint-disable */
/// This file is auto generated - do not edit manually
export const QuickSearchPlaceholder = 'Website.Search.QuickSearchPlaceholder';
export const ExpandSearch = 'Website.Search.ExpandSearch';
export const SearchFor = 'Website.Search.SearchFor';
export const Clear = 'Website.Search.Clear';
export const HiddenCloseSearchButton = 'Website.Search.HiddenCloseSearchButton';
